import React, {useContext, useEffect} from "react";
import {AppFunctionsContext} from "../../contexts/AppFunctionsContext";
import {OrderContext} from "../../contexts/OrderContext";

export default function IPGCompletionScreenFunction(props: { children: any }) {
    const orderContext = useContext(OrderContext);
    const order = orderContext.order;
    const appFunctions = useContext(AppFunctionsContext);

    useEffect(() => {
        if (order == null)
            appFunctions.appNavigator.back();
    }, [order]);

    return <>
        {props.children}
    </>
}
